<div class="slash-palette" role="listbox" aria-label="Actions rapides">
  @if (filteredActions().length === 0) {
    <p class="slash-palette__empty">Aucune action ne correspond. Essayez un autre mot.</p>
  } @else {
    @for (action of filteredActions(); track action.id; let i = $index) {
      <button
        type="button"
        class="slash-palette__item"
        [class.slash-palette__item--active]="i === activeIndex()"
        role="option"
        [attr.aria-selected]="i === activeIndex()"
        (click)="onSelect(action.id)"
      >
        <ng-icon [name]="action.icon" size="16" />
        <span>{{ action.label }}</span>
      </button>
    }
  }
</div>
